import { useAbility } from '../../users/AbilityContext';
import { SearchableEntityType } from '../globalSearch.types';
import { RESULT_ACCESS } from '../lib/resultAccess';
import { ResultAbilityRule } from '../lib/resultAccess.types';

const useResultAccess = () => {
  const ability = useAbility();

  const isAllowed = (rule?: ResultAbilityRule) => !rule || ability.can(rule.action, rule.subject);

  const canOpenEntity = (entityType: SearchableEntityType) =>
    isAllowed(RESULT_ACCESS[entityType]?.open);

  const canUseItemAction = (entityType: SearchableEntityType) =>
    isAllowed(RESULT_ACCESS[entityType]?.itemAction);

  return { canOpenEntity, canUseItemAction };
};

export default useResultAccess;
